import {TYPES as ACC_TYPES} from "../accreditation-action-type.constants";
import {IDS} from "./settings-action-id.constants";
import {TAB_HIDE} from '../../../common/tabs/tabs.constants';

export const settingsAbstractState = {
    name: IDS.app_accreditation_scheme_settings,
    abstract: true,
    redirectTo: IDS.app_accreditation_scheme_settings_dashboard,
    url: '/:itemCode',
}


export const settingsDashboardState = {
    name: IDS.app_accreditation_scheme_settings_dashboard,
    url: '/settings',
    component: 'dashboard',
};


export const frameworkDetailsState = {
    name: IDS.app_accreditation_scheme_settings_framework_details,
    url: '/framework-details',
    component: 'frameworkDetails',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: ACC_TYPES.SIMPLE_STD_TREE_UNSELECT_ALL,
        });
    }
};
frameworkDetailsState.onEnter.$inject = ['$ngRedux'];


export const enabledAccountsTabsState = {
    name: IDS.app_accreditation_scheme_settings_enabled,
    redirectTo: IDS.app_accreditation_scheme_settings_enabled_head_offices,
    url: '/enabled',
    component: 'tabs'
};

export const enabledAccountsHeadOfficesState = {
    name: IDS.app_accreditation_scheme_settings_enabled_head_offices,
    url: '/headOffices',
    component: 'headOffices',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: 'TAB_HIDE',
            id: IDS.app_accreditation_scheme_settings_enabled,
            state: [
                IDS.app_accreditation_scheme_settings_enabled_site_locations,
            ]
        });
        $ngRedux.dispatch({
            type: ACC_TYPES.SIMPLE_STD_TREE_UNSELECT_ALL,
        });
    }
};
enabledAccountsHeadOfficesState.onEnter.$inject = ['$ngRedux'];

export const enabledAccountsSiteLocationsState = {
    name: IDS.app_accreditation_scheme_settings_enabled_site_locations,
    url: '/siteLocations',
    component: 'siteLocations',
};

export const requirementsTabsState = {
    name: IDS.app_accreditation_scheme_settings_requirements,
    redirectTo: IDS.app_accreditation_scheme_settings_requirements_list,
    url: '/requirements',
    component: 'tabs',
};

export const requirementsListState = {
    name: IDS.app_accreditation_scheme_settings_requirements_list,
    url: '/list',
    component: 'requirementsList',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: 'TAB_HIDE',
            id: IDS.app_accreditation_scheme_settings_requirements,
            state: [
                IDS.app_accreditation_scheme_settings_requirements_imports
            ]
        });
    }
};
requirementsListState.onEnter.$inject = ['$ngRedux'];

export const requirementsImportsState = {
    name: IDS.app_accreditation_scheme_settings_requirements_imports,
    url: '/imports',
    component: 'requirementsImports',
};

export const evidenceTabsState = {
    name: IDS.app_accreditation_scheme_settings_evidence,
    redirectTo: IDS.app_accreditation_scheme_settings_evidence_list,
    url: '/requirement-evidence',
    component: 'tabs'
};

export const evidenceListState = {
    name: IDS.app_accreditation_scheme_settings_evidence_list,
    url: '/list',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: TAB_HIDE,
            id: IDS.app_accreditation_scheme_settings_evidence,
            state: [
                IDS.app_accreditation_scheme_settings_evidence_details,
                IDS.app_accreditation_scheme_settings_evidence_applicable_sites,
                IDS.app_accreditation_scheme_settings_evidence_add,
                IDS.app_accreditation_scheme_settings_evidence_imports,
            ]
        });
    }
};
evidenceListState.onEnter.$inject = ['$ngRedux'];

export const evidenceDetailState = {
    name: IDS.app_accreditation_scheme_settings_evidence_details,
    url: '/details',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: TAB_HIDE,
            id: IDS.app_accreditation_scheme_settings_evidence,
            state: [
                IDS.app_accreditation_scheme_settings_evidence_applicable_sites,
            ]
        });
    }
};
evidenceDetailState.onEnter.$inject = ['$ngRedux'];

export const evidenceApplicableSitesState = {
    name: IDS.app_accreditation_scheme_settings_evidence_applicable_sites,
    url: '/applicable-sites?hofUuid',
};

export const evidenceAddState = {
    name: IDS.app_accreditation_scheme_settings_evidence_add,
    url: '/add',
};

export const evidenceImportsState = {
    name: IDS.app_accreditation_scheme_settings_evidence_imports,
    url: '/imports',
}

export const siteLocationRequirementEvidenceTabsState = {
    name: IDS.app_accreditation_scheme_settings_slo_required_docs,
    redirectTo: IDS.app_accreditation_scheme_settings_slo_required_docs_list,
    url: '/slo-required-doc',
    component: 'tabs'
};

export const siteLocationRequirementEvidenceListState = {
    name: IDS.app_accreditation_scheme_settings_slo_required_docs_list,
    url: '/list',
    // component: 'siteLocationRequirementEvidenceList',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: 'TAB_HIDE',
            id: IDS.app_accreditation_scheme_settings_slo_required_docs,
            state: [
                IDS.app_accreditation_scheme_settings_slo_required_docs_details,
                IDS.app_accreditation_scheme_settings_slo_required_docs_add,
                IDS.app_accreditation_scheme_settings_slo_required_docs_imports,
            ]
        });
    }
};
siteLocationRequirementEvidenceListState.onEnter.$inject = ['$ngRedux'];

export const siteLocationRequirementEvidenceDetailState = {
    name: IDS.app_accreditation_scheme_settings_slo_required_docs_details,
    url: '/details',
    // component: 'siteLocationRequirementEvidenceDetails',
};


export const siteLocationRequirementEvidenceAddState = {
    name: IDS.app_accreditation_scheme_settings_slo_required_docs_add,
    url: '/add',
    // component: 'siteLocationRequirementEvidenceDetails',
};

export const siteLocationRequirementEvidenceImportsState = {
    name: IDS.app_accreditation_scheme_settings_slo_required_docs_imports,
    url: '/imports',
}


